export default __webpack_public_path__ + "static/media/G4LS_150.86df299e.jpg";